import { get } from 'lodash';

export const getColumnWithSlotSize = (array, chunkSize) => {
    const result = [];
    let index = 0;

    while (index < array.length) {
        result.push(array.slice(index, index + chunkSize));
        index += chunkSize;
    }

    return result;
};

export const formatCustomerName = (customers = [], key = 'name') => {
    const names = [];
    customers.forEach((c) => {
        if (!names.includes(get(c, [key]))) {
            names.push(get(c, [key]));
        }
    });
    return names.join(', ');
};
